import Button from "@mostrans/web-components/components/base/Button";
import { Icon } from "@mui/material";
import React, { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { useGetEmployeeDemographyAdminWithFilter } from "../../../../GQL/Demography/hooks/useGetEmployeeDemographyAdminWithFilter";
import PageContainer from "../../../../components/Container/PageContainer";
import { titleAtoms } from "../../../../shared/atoms/titleAtoms";
import { useModals } from "../../../../shared/hooks/useModals";
import HeaderFilterDemography from "./HeaderFilterDemography";
import ListingDemography from "./ListingDemography";

export default function DemographyManagement() {
  const setTitle = useSetRecoilState(titleAtoms);
  const { showModal } = useModals();
  const { dataDemography } = useGetEmployeeDemographyAdminWithFilter();

  useEffect(() => {
    setTitle("Demography Management");
  }, []);

  return (
    <PageContainer>
      <HeaderFilterDemography />
      {!dataDemography.loading && (
        <div className="mt-2">
          <Button
            variant="contained"
            startIcon={<Icon>add_circle</Icon>}
            onClick={() => showModal("createCategory")}
          >
            Add New Demography
          </Button>
        </div>
      )}
      <ListingDemography />
    </PageContainer>
  );
}
